import React from 'react'
import Vimeo from './vimeo'

const Slide = ({ slide }) => {
  // check for video only slides
  if (slide.image === null) {
    if (slide.video_service === 'vimeo.com') {
      return (
        <div className={`w-full h-full text-white relative min-h-full`}>
          <Vimeo videoId={slide.video_id} />
        </div>
      )
    }
  }

  // default slide type
  const slideContent = (
    <div className={`w-full h-full text-white relative min-h-full`}>
      <div className='absoulte left-0 right-0 top-0 bottom-0'>
        <img
          src={slide.image || 'https://placehold.co/1280x720/ddd/ddd'}
          alt={slide.title}
          className='w-full h-full object-cover block'
        />
      </div>

      <div
        className={`hidden sm:block absolute left-0 ${slide.title_position} w-full p-2 sm:p-3 pointer-events-none`}
      >
        <div className='bg-black text-white p-2 sm:p-3 rounded  flex flex-col opacity-65'>
          <div className='flex flex-col sm:flex-row sm:items-baseline sm:justify-between w-full'>
            <div className='font-serif text-xl'>{slide.title}</div>
            {slide.top_line && (
              <div
                className='text-sm'
                dangerouslySetInnerHTML={{ __html: slide.top_line }}
              />
            )}
          </div>
          {slide.summary && (
            <div
              className='text-sm hidden sm:block'
              dangerouslySetInnerHTML={{ __html: slide.summary }}
            />
          )}
        </div>
      </div>
      {slide.certificate && (
        <div
          className={`absolute ${slide.certificate_class} w-10 h-10 sm:w-15 sm:h-15 p-2 sm:p-3 pointer-events-none`}
        >
          <img src={slide.certificate.image} alt={slide.certificate.name} />
        </div>
      )}
      <div className='sm:hidden rounded-b bg-white dark:bg-black text-black dark:text-white p-2 flex flex-col items-center pointer-events-none'>
        <div className='font-serif'>{slide.title}</div>
        <div
          className='text-sm'
          dangerouslySetInnerHTML={{ __html: slide.top_line }}
        />
      </div>
    </div>
  )

  // Wrap in link if URL is provided
  if (slide.url) {
    return (
      <a href={slide.url} className='block w-full h-full cursor-pointer'>
        {slideContent}
      </a>
    )
  }

  return slideContent
}

export default Slide
